import useEvent from '@lyearn/core/hooks/useEvent';
import { Trans, useTranslation } from '@lyearn/i18n';
import { Trash2Fill } from '@lyearn/icons';
import { Typography, useSnackbar } from '@lyearn/ui';
import useResponse from '@/hooks/useResponse';

import { useDeleteFileMutation } from '../graphql/mutations/generated/deleteCategory';
import { CategoryType } from '../types';

interface UseDeleteCategoryProps {
  onSuccess?: () => void;
}

function useDeleteCategory({ onSuccess }: UseDeleteCategoryProps) {
  const { t } = useTranslation();
  const [{ fetching }, executeDeleteCategory] = useDeleteFileMutation();
  const { handleResponse } = useResponse();
  const { showSnackbar } = useSnackbar();

  const onDelete = useEvent(async (category: CategoryType) => {
    const result = await executeDeleteCategory({ data: { fileId: category.id } });
    handleResponse({
      condition: Boolean(result.data?.deleteFile?.success),
      onSuccess: () => {
        showSnackbar({
          message: (
            <Trans
              components={{ label: <Typography variant="label-02" /> }}
              i18nKey="Discover:Category.Admin.CategoryHasBeenDeleted"
              values={{ name: category.name }}
            />
          ),
          startIcon: <Trash2Fill fillColorToken="icon-placeholder" />,
        });

        onSuccess?.();
      },
    });
  });

  return {
    fetching,
    onDelete,
  };
}

export default useDeleteCategory;
